// All website content for Die Haushelden
export const company = {
  name: 'Die Haushelden',
  tagline: 'Sanierung & Objektpflege',
  owner: 'Justin Brumbach',
  legalForm: 'Einzelunternehmen',
  vatId: 'DE463843005',
  hosting: 'Emergent',
  phone: '0152 35826898',
  phoneRaw: '015235826898',
  email: 'Info@diehaushelden-sanierung.de',
  address: { street: 'Hauptstraße 10', zip: '23847', city: 'Rethwisch' },
  hours: [
    { d: 'Montag – Freitag', t: '09:00 – 18:00 Uhr' },
    { d: 'Samstag', t: '09:00 – 16:00 Uhr' },
    { d: 'Sonntag', t: 'Geschlossen' },
  ],
};

export const areas = [
  'Hamburg', 'Lübeck', 'Rethwisch', 'Bad Oldesloe',
  'Hannover', 'Bremen', 'Ingolstadt', 'München',
  'Nürnberg', 'Regensburg', 'Augsburg',
];

export const services = [
  {
    id: 'steinreinigung',
    title: 'Steinreinigung',
    popular: true,
    intro: 'Professionelle Reinigung von Einfahrten, Terrassen, Gehwegen, Höfen und Pflasterflächen – gründlich und materialschonend.',
    text: 'Wir entfernen Moos, Algen, Schmutz und Ablagerungen und sorgen für ein sichtbar gepflegtes und hochwertiges Erscheinungsbild.',
    bullets: ['Pflasterreinigung', 'Terrassenreinigung', 'Einfahrten', 'Gehwege', 'Höfe'],
    image: '/assets/svc-steinreinigung.jpg',
  },
  {
    id: 'fugenarbeiten',
    title: 'Fugenarbeiten',
    intro: 'Fugenarbeiten für Pflaster- und Steinflächen mit sauberer, gleichmäßiger Oberfläche.',
    text: 'Ob lose oder feste Verfugung – wir erneuern beschädigte oder ausgespülte Fugen passend zur jeweiligen Fläche.',
    bullets: ['Lose Verfugung', 'Feste Verfugung', 'Erneuerung', 'Pflasterfugen'],
    image: '/assets/svc-fugenarbeiten.jpg',
  },
  {
    id: 'impraegnierung',
    title: 'Imprägnierung',
    intro: 'Imprägnierungen für Stein- und Pflasterflächen zum langfristigen Schutz gereinigter Oberflächen.',
    text: 'Die Behandlung unterstützt den Schutz vor Feuchtigkeit, Verschmutzungen und Witterungseinflüssen und erhält die gepflegte Optik.',
    bullets: ['Feuchtigkeitsschutz', 'Schmutzschutz', 'UV-Schutz', 'Werterhalt'],
    image: '/assets/svc-impraegnierung.jpg',
  },
  {
    id: 'fassadenreinigung',
    title: 'Fassadenreinigung',
    popular: true,
    intro: 'Fassaden von Wohn- und Gewerbeobjekten – gründlich und schonend auf die jeweilige Oberfläche abgestimmt.',
    text: 'Wir entfernen Algen, Grünbelag, Schmutz und Verfärbungen und sorgen für ein gepflegtes Gesamtbild.',
    bullets: ['Algen entfernen', 'Grünbelag', 'Verfärbungen', 'Wohn- & Gewerbe'],
    image: '/assets/svc-fassadenreinigung.jpg',
  },
  {
    id: 'dachreinigung',
    title: 'Dachreinigung',
    intro: 'Professionelle Dachreinigungen befreien Dachflächen gründlich von hartnäckigen Verschmutzungen.',
    text: 'Ob Moos, Algen, Flechten oder Ablagerungen – wir sorgen für eine saubere und sichtbar aufgewertete Dachoberfläche.',
    bullets: ['Moos & Algen', 'Flechten', 'Ablagerungen', 'Ziegel & Beton'],
    image: '/assets/svc-dachreinigung.jpg',
  },
  {
    id: 'dachbeschichtung',
    title: 'Dachbeschichtung',
    intro: 'Dachbeschichtungen zur optischen Aufwertung bestehender Dachflächen.',
    text: 'Nach gründlicher Vorbereitung wird die Oberfläche neu beschichtet und erhält dadurch eine gleichmäßige, gepflegte und moderne Optik.',
    bullets: ['Aufwertung', 'Neue Optik', 'Farbe nach Wahl', 'Langzeitschutz'],
    image: '/assets/svc-dachbeschichtung.jpg',
  },
  {
    id: 'steinteppich',
    title: 'Steinteppich',
    intro: 'Wir gestalten alte oder unansehnliche Flächen mit hochwertigem Steinteppich komplett neu.',
    text: 'Ob Treppen, Balkone oder Terrassen – bestehende Flächen werden fachgerecht vorbereitet und erhalten eine moderne, hochwertige Oberfläche.',
    bullets: ['Treppen', 'Balkone', 'Terrassen', 'Rutschfest'],
    image: '/assets/svc-steinteppich.jpg',
  },
  {
    id: 'malerarbeiten',
    title: 'Malerarbeiten',
    intro: 'Malerarbeiten aller Art für Innen- und Außenbereiche – zuverlässig und sauber ausgeführt.',
    text: 'Ob Wände, Decken, Fassaden, Holzflächen, Türen oder Zäune – wir übernehmen Neuanstriche, Auffrischungen und Ausbesserungen.',
    bullets: ['Innen & Außen', 'Wände & Decken', 'Holz & Zäune', 'Ausbesserungen'],
    image: '/assets/svc-malerarbeiten.jpg',
  },
  {
    id: 'pflasterarbeiten',
    title: 'Pflasterarbeiten',
    intro: 'Pflasterarbeiten rund um Haus und Grundstück – von Reparaturen bis zur kompletten Neugestaltung.',
    text: 'Ob Einfahrten, Terrassen, Wege oder Hofflächen – wir sorgen für einen fachgerechten Aufbau und eine saubere Verlegung.',
    bullets: ['Einfahrten', 'Terrassen', 'Hofflächen', 'Neuverlegung'],
    image: '/assets/svc-pflasterarbeiten.jpg',
  },
  {
    id: 'sanierung',
    title: 'Sanierungsarbeiten',
    intro: 'Sanierungs- und Ausbesserungsarbeiten rund um Ihre Immobilie – zuverlässig und fachgerecht.',
    text: 'Ob Wände, Fassaden, Außenflächen oder beschädigte Bereiche – wir sorgen für eine saubere und nachhaltige Aufwertung.',
    bullets: ['Wände & Fassaden', 'Außenflächen', 'Reparaturen', 'Aufwertung'],
    image: '/assets/svc-sanierung.jpg',
  },
  {
    id: 'schimmel',
    title: 'Schimmelentfernung',
    intro: 'Professionelle Schimmelentfernung für betroffene Innenbereiche.',
    text: 'Wir behandeln belastete Flächen gründlich und fachgerecht und beraten Sie zu sinnvollen weiteren Maßnahmen.',
    bullets: ['Innenräume', 'Schimmelpilz', 'Beratung', 'Nachhaltig'],
    image: '/assets/svc-schimmel.jpg',
  },
  {
    id: 'hausmeisterservice',
    title: 'Hausmeisterservice',
    intro: 'Zuverlässiger Hausmeisterservice für private und gewerbliche Immobilien.',
    text: 'Ob Kontrollen, kleinere Reparaturen, Pflegearbeiten oder Objektbetreuung – wir kümmern uns regelmäßig und zuverlässig um Ihr Objekt.',
    bullets: ['Kontrollen', 'Reparaturen', 'Pflegearbeiten', 'Objektbetreuung'],
    image: '/assets/svc-hausmeister.jpg',
  },
  {
    id: 'garten',
    title: 'Garten- & Grünpflege',
    intro: 'Garten- und Grünpflege rund um Haus, Grundstück und Gewerbeflächen.',
    text: 'Ob Rasenpflege, Heckenschnitt, Rückschnitt oder allgemeine Pflegearbeiten – wir sorgen für gepflegte Außenanlagen.',
    bullets: ['Rasenpflege', 'Heckenschnitt', 'Rückschnitt', 'Laubentfernung'],
    image: '/assets/svc-garten.jpg',
  },
  {
    id: 'winterdienst',
    title: 'Winterdienst',
    intro: 'Zuverlässiger Winterdienst für private und gewerbliche Flächen.',
    text: 'Ob Gehwege, Zufahrten, Parkplätze oder Außenbereiche – wir übernehmen Räum- und Streuarbeiten zuverlässig und bedarfsgerecht.',
    bullets: ['Gehwege', 'Zufahrten', 'Parkplätze', 'Räum- & Streudienst'],
    image: '/assets/svc-winterdienst.jpg',
  },
  {
    id: 'entruempelung',
    title: 'Entrümpelung',
    intro: 'Entrümpelungen und Räumungen aller Art – schnell, zuverlässig und diskret.',
    text: 'Ob Wohnungen, Häuser, Keller, Garagen oder Gewerbeflächen – wir kümmern uns auf Wunsch auch um Abtransport und Entsorgung.',
    bullets: ['Wohnungen', 'Keller & Garagen', 'Gewerbeflächen', 'Entsorgung'],
    image: '/assets/svc-entruempelung.jpg',
  },
  {
    id: 'objektpflege',
    title: 'Objektpflege',
    intro: 'Umfassende Objektpflege für Wohn- und Gewerbeimmobilien aus einer Hand.',
    text: 'Von Reinigung und Außenpflege bis zu Hausmeisterarbeiten und kleineren Reparaturen sorgen wir für ein dauerhaft gepflegtes Objekt.',
    bullets: ['Aus einer Hand', 'Reinigung', 'Außenpflege', 'Reparaturen'],
    image: '/assets/svc-objektpflege.jpg',
  },
  {
    id: 'reinigung',
    title: 'Reinigungsarbeiten',
    intro: 'Reinigungsarbeiten rund um Gebäude, Grundstücke und Außenanlagen.',
    text: 'Ob Gemeinschaftsbereiche, Außenflächen oder stark beanspruchte Bereiche – wir sorgen für Sauberkeit, Ordnung und ein gepflegtes Erscheinungsbild.',
    bullets: ['Gemeinschaftsbereiche', 'Außenflächen', 'Grundreinigung', 'Regelmäßig'],
    image: '/assets/svc-reinigung.jpg',
  },
];

export const testimonials = [
  {
    text: 'Die Kommunikation war unkompliziert, der Termin wurde eingehalten und das Ergebnis war sichtbar besser als erwartet. Gerade für unser Firmengebäude war der gepflegte erste Eindruck wichtig.',
    author: 'Gewerbekunde aus Hamburg',
  },
  {
    text: 'Unsere Einfahrt und die Terrasse waren über die Jahre stark verschmutzt. Nach der Reinigung sah alles wieder deutlich heller und gepflegter aus. Besonders gut: die ehrliche Einschätzung vorab.',
    author: 'Privatkunde, Region Lübeck',
  },
  {
    text: 'Als Hausverwaltung brauchen wir Dienstleister, auf die man sich verlassen kann. Die Außenflächen einer Wohnanlage wurden sauber und ordentlich bearbeitet – professionell und zuverlässig.',
    author: 'Hausverwaltung, Raum München',
  },
  {
    text: 'Von der Anfrage bis zur Umsetzung lief alles sauber. Fotos geschickt, Rückmeldung bekommen, Termin vereinbart und die Fläche wie besprochen gereinigt. Kein unnötiges Hin und Her.',
    author: 'Kunde aus Bad Oldesloe',
  },
  {
    text: 'Übernimmt bei uns regelmäßig kleinere Pflegearbeiten. Rasen, Hecken, Laub und Wege sind seitdem deutlich besser im Griff. Praktisch, einen festen Ansprechpartner zu haben.',
    author: 'Immobilienbesitzer aus Bremen',
  },
  {
    text: 'Die Dachreinigung und Beschichtung wurde exakt wie besprochen ausgeführt. Sauberer Arbeitsplatz, faires Angebot und ein wirklich sichtbares Ergebnis.',
    author: 'Privatkunde aus Rethwisch',
  },
];

export const faqs = [
  {
    q: 'Für wen sind Die Haushelden der richtige Ansprechpartner?',
    a: 'Für Gewerbekunden, Hausverwaltungen, Immobilienbesitzer, Unternehmen und Eigentümergemeinschaften – ebenso für Privatkunden. Wir betreuen kleine wie große Objekte zuverlässig.',
  },
  {
    q: 'Welche Leistungen bieten Die Haushelden an?',
    a: 'Unter anderem Steinreinigung, Fugenarbeiten, Imprägnierung, Fassaden- und Dachreinigung, Dachbeschichtung, Steinteppich, Maler-, Pflaster- und Sanierungsarbeiten, Schimmelentfernung, Hausmeisterservice, Garten- & Grünpflege, Winterdienst, Entrümpelung sowie umfassende Objektpflege.',
  },
  {
    q: 'Bieten Sie auch regelmäßige Objektbetreuung an?',
    a: 'Ja. Neben einzelnen Arbeiten übernehmen wir regelmäßige Pflegeintervalle, Hausmeisterservice und komplette Objektbetreuung – ideal für Hausverwaltungen und Gewerbeobjekte.',
  },
  {
    q: 'Was kostet eine Reinigung oder Sanierung?',
    a: 'Die Kosten hängen von Fläche, Zustand, Material, Zugänglichkeit und Leistungsumfang ab. Nach Anfrage oder Besichtigung erstellen wir Ihnen ein individuelles Angebot.',
  },
  {
    q: 'In welchen Regionen sind Die Haushelden tätig?',
    a: 'Wir sind aktiv in Hamburg, Lübeck, Rethwisch, Bad Oldesloe, Hannover, Bremen, Ingolstadt, München, Nürnberg, Regensburg und Augsburg – weitere Regionen auf Anfrage möglich.',
  },
  {
    q: 'Können mehrere Leistungen kombiniert werden?',
    a: 'Ja. Reinigung, Sanierung, Garten- und Objektpflege lassen sich individuell zu einem passenden Paket kombinieren – bequem aus einer Hand.',
  },
  {
    q: 'Kann ich Fotos für eine erste Einschätzung schicken?',
    a: 'Ja, sehr gerne. Fotos der Fläche helfen uns, Zustand und Aufwand realistisch einzuschätzen. Bei größeren Objekten ist zusätzlich eine Besichtigung sinnvoll.',
  },
];

export const process = [
  { n: '01', t: 'Anfrage stellen', d: 'Kurze Anfrage mit Adresse, Objektart und gewünschter Leistung. Fotos helfen bei einer ersten Einschätzung.' },
  { n: '02', t: 'Besichtigung oder Einschätzung', d: 'Je nach Objekt prüfen wir die Fläche vor Ort oder anhand Ihrer Angaben und Bilder.' },
  { n: '03', t: 'Angebot erhalten', d: 'Sie erhalten ein passendes Angebot für die gewünschte Leistung – transparent und fair.' },
  { n: '04', t: 'Umsetzung planen', d: 'Termin, Ablauf und Umfang werden gemeinsam abgestimmt – einmalig, saisonal oder regelmäßig.' },
  { n: '05', t: 'Durchführung', d: 'Die vereinbarten Arbeiten werden sorgfältig ausgeführt und das Objekt gepflegt übergeben.' },
];

export const targetGroups = [
  { t: 'Hausverwaltungen', d: 'Reinigung und Pflege von Wohnanlagen, Eingangsbereichen, Wegen, Parkflächen und Gemeinschaftsflächen.' },
  { t: 'Gewerbe & Unternehmen', d: 'Gepflegte Außenbereiche für Bürogebäude, Firmenflächen, Kundenparkplätze und repräsentative Immobilien.' },
  { t: 'Einzelhandel & Gastronomie', d: 'Saubere Terrassen, Eingangsbereiche und Außenflächen für einen starken ersten Eindruck bei Gästen.' },
  { t: 'Immobilienbesitzer', d: 'Werterhalt und gepflegte Optik für private, gewerbliche und vermietete Immobilien.' },
  { t: 'Kommunen & öffentliche Bereiche', d: 'Pflege, Reinigung und Instandhaltung von Wegen und öffentlich sichtbaren Bereichen nach Absprache.' },
  { t: 'Privatkunden', d: 'Reinigung, Sanierung und Pflege rund ums Haus – von der Einfahrt bis zum Dach.' },
];
